const producerFilterConfig = {
  type: "object",
  properties: {
    search: {
      type: "string",
    },
    // Selector con las opciones Liquidado, Pendiente y todas con valor por defecto en liquidado
    status: {
      type: "string",
      oneOf: [
        {
          const: "liquidated",
          title: "Liquidado",
        },
        {
          const: "pending",
          title: "Pendiente",
        },
        {
          const: "all",
          title: "Todas",
        },
      ],
      default: "pending",
    },
  },
};

const getProducerFiltersConfig: any = () => {
  return producerFilterConfig;
};

export default getProducerFiltersConfig;
